import React, { Component } from 'react';
import * as LoginAction from './actions';
import Cookies from 'universal-cookie';
import NavigateRoute from '../helpers/validateRoutes';
import _ from 'lodash';
import jwt_decode from 'jwt-decode';

const cookies = new Cookies();

class Authenticator extends NavigateRoute {
	userLoginWithPassword = async (
		userName,
		password,
		googleAuthCode = null,
		validatePassword = null,
	) => {
		let json = {};

		json = {
			email: userName.toLowerCase().trim(),
			password: password,
		};

		if (googleAuthCode !== null) {
			json = { ...json, googleAuthCode };
		}
		let response = await LoginAction.verifyLoginWithPassword(json);

		if (response[0] === true) {
			if (validatePassword == true) {
				this.setState(
					{
						showIdleModal: false,
					},
					() => {
						localStorage.removeItem('isIdle');
					},
				);
			} else {
				let decode = jwt_decode(response[1].accessToken);

				if (
					_.has(response[1], 'accessibleShops') &&
					_.size(response[1].accessibleShops) > 0
				) {
					if (localStorage.getItem('isIdle')) {
						localStorage.removeItem('isIdle');
					}
					localStorage.setItem('usertoken', response[1].accessToken);

					cookies.set('usertoken', response[1].accessToken, {
						domain:
							window.location.host.split('.')[1] === 'huemn'
								? '.huemn.com'
								: window.location.hostname,
						path: '/',
					});

					if (localStorage.getItem('usertoken')) {
						if (_.size(response[1].accessibleShops) > 0)
							this.props.navigate(
								`/${response[1].accessibleShops[0]['vendorId']}/shoots`,
							);
					}
				} else {
					this.setState({
						isLoading: false,
						errorMessage: 'Not Authorized',
					});
				}
			}
		} else {
			this.setState({
				isLoading: false,
				errorMessage: response[1].message,
			});
		}
	};
	getUserDetails = async () => {
		let usertoken = localStorage.getItem('usertoken');

		let response = await LoginAction.userDetails(usertoken);

		if (response[0] === true) {
			this.setState(
				{
					userDetails: response[1],
					isUserDetailsLoading: false,
				},
				() => {
					if (_.has(this, 'checkOverflow')) {
						this.checkOverflow();
					}
				},
			);
		}
	};

	get2FADetails = async () => {
		let response = await LoginAction.get2FAStatus(this.state.userName);
		if (response[0] === true) {
			this.setState({
				isSubmitting: false,
			});
			if (_.has(response[1], 'is2FAEnabled')) {
				if (
					response[1].is2FAEnabled &&
					_.has(response[1], 'is2FAConfigured') &&
					response[1].is2FAConfigured
				) {
					console.log(1);
					this.setState({
						show2fa: true,
					});
				} else {
					await this.userLoginWithPassword(this.state.userName, this.state.password);
				}
			} else {
				console.log(2);
			}
		} else {
			this.setState({
				isLoading: false,
				errorMessage: response[1].message,
			});
		}
	};
}

export default Authenticator;
